module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-four1.52f9ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-four1.png
// module id = /s/v
// module chunks = 0